// extracted by mini-css-extract-plugin
module.exports = {"list__table":"templateModale_list__table__166lt"};